<template>
  <v-simple-table dense>
    <template v-slot:default>
      <tbody>
        <template v-for="(item, index) in items">
          <tr
            :key="index"
            v-if="!item.hide"
            class="n-hov"
            :style="item.trStyle ? item.trStyle : ''"
          >
            <td v-if="!item.fileData && !item.checkboxList" :style="`width:${leftWidth}`">
              <template v-if="item.addBullet">
                <div style="display: flex">
                  <v-icon>mdi-circle-small</v-icon>
                  <strong style="position: relative; display: flex"
                    >{{ getTitle(item.title)
                    }}<el-tooltip
                      v-if="item.tooltip"
                      :tooltip="item.tooltip"
                      list
                    />
                  </strong>
                </div>
              </template>
              <template v-else-if="item.canCopy">
                <strong style="position: relative; display: flex">
                  {{ getTitle(item.title) }}
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        dense
                        class="table-action mx-1"
                        @click="copyData(item.value)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-content-copy
                      </v-icon>
                    </template>
                    <div class="tooltip-text">Kopijuoti</div>
                  </v-tooltip>
                </strong>
              </template>
              <template v-else>
                <strong style="position: relative; display: flex"
                  >{{ getTitle(item.title)
                  }}<el-tooltip
                    v-if="item.tooltip"
                    :tooltip="item.tooltip"
                    list
                  />
                </strong>
              </template>
            </td>
            <td v-if="item.enumName">
              <el-table-enum :enumName="item.enumName" :item="item.value" />
            </td>
            <td v-else-if="item.file">
              <el-table-download
                :title="item.value"
                :file="item.file"
              ></el-table-download>
            </td>
            <td v-else-if="item.fileData">
              <a @click="download(item)">{{ item.title }}</a>
            </td>
            <td v-else-if="item.link">
              <a @click="linkItem(item)">{{ item.value }}</a>
            </td>
            <td v-else-if="item.html">
              <span v-html="item.value"></span>
            </td>
            <td v-else-if="item.criteriaModal">
              <v-icon 
                dense
                class="table-action mx-1"  
                @click="showCriteriaModal()"
              >
                mdi-eye
              </v-icon>
            </td>
            <td colspan="2" v-else-if="item.checkboxList">
              <strong>{{ getTitle(item.title) }}</strong>
              <template v-for="listItem in item.list">
                <el-checkbox
                  :key="listItem.id"
                  class="pt-0 mt-0"
                  :label="listItem.text"
                  v-model="listItem.value"
                > 
                </el-checkbox>
              </template>
            </td>
            <td v-else>
              {{ item.value || '-' }}
            </td>
          </tr>
        </template>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: 'ElSimpleTable',
  props: {
    items: Array,
    leftWidth: String,
  },
  computed: {},
  methods: {
    showCriteriaModal() {
      this.$emit('showCriteriaModal')
    },
    linkItem(item) {
      this.$emit('linkItem', item)
    },
    download(file) {
      var fileLink = document.createElement('a')
      fileLink.href = file.fileData
      fileLink.setAttribute('download', file.title)
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    getTitle(title) {
      return title ? `${this.$t(title)}:` : ''
    },
    copyData(text) {
      const textArea = document.createElement('textarea')
      textArea.value = text
      document.body.appendChild(textArea)
      var selection = document.getSelection()
      var range = document.createRange()
      range.selectNode(textArea)
      selection.removeAllRanges()
      selection.addRange(range)
      document.execCommand('copy')
      selection.removeAllRanges()
      document.body.removeChild(textArea)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/elements.scss';
</style>
